import { useEffect, useState } from "react";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "../firebase";
import Login from "../pages/Login";
import React from "react";

interface Props {
  children: React.ReactNode;
}



export default function AuthGate({ children }: Props): React.ReactElement {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
    });
  }, []);

  if (loading) return <p>Loading...</p>;

  if (!user)
    return (
      <div style={{ maxWidth: "40%", margin: "auto" }}>
        <Login />
      </div>
    );

  return <>{children}</>; // This ensures it's a JSX.Element
}